import $ from 'jquery';
import { revieveAddToBag } from "../../modules/revieve-try-on";
import init from 'modules/heart-product'
import initProductSectionViewMore from 'modules/product-section-view-more'

$(function() {
    $('.js-revieve-full-look').on('click', (e) => {
        e.preventDefault();
        if (window.rcProps.activeRevievePlugin === 'FULL_LOOK') {
            openPlugin();
        } else {
            window.activateRevieveFullLook(openPlugin);
        }
    });

    revieveAddToBag();

    init('#main-content', '.js-favorite-button');

    initProductSectionViewMore('#main-content');
});

function openPlugin() {
    Revieve.API.show();
    logEngagement(window.location.href, 'VTO', 'Open');
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/landing/index.js